import { render } from "./TrainingAttendanceList.vue?vue&type=template&id=22173fc4"
import script from "./TrainingAttendanceList.vue?vue&type=script&lang=ts"
export * from "./TrainingAttendanceList.vue?vue&type=script&lang=ts"
script.render = render

export default script